import React, { Component } from "react";
import { Grid, Tab, Button } from "semantic-ui-react";
import PreReqCheckbox from "./PreReqCheckbox";
import StepOneCheckbox from "./StepOneCheckbox";
import StepTwoCheckbox from "./StepTwoCheckbox";
import StepThreeCheckbox from "./StepThreeCheckbox";
import StepFourCheckbox from "./StepFourCheckbox";
import StepFiveCheckbox from "./StepFiveCheckbox";

const panes = [
  {
    menuItem: 'Pre-req',
    render: () => <Tab.Pane attached={false}><PreReqCheckbox /></Tab.Pane>,
  },
  {
    menuItem: '1',
    render: () => <Tab.Pane attached={false}><StepOneCheckbox /></Tab.Pane>,
  },
  {
    menuItem: '2',
    render: () => <Tab.Pane attached={false}><StepTwoCheckbox /></Tab.Pane>,
  },
  {
    menuItem: '3',
    render: () => <Tab.Pane attached={false}><StepThreeCheckbox /></Tab.Pane>,
  },
  {
    menuItem: '4',
    render: () => <Tab.Pane attached={false}><StepFourCheckbox /></Tab.Pane>,
  },
  {
    menuItem: '5',
    render: () => <Tab.Pane attached={false}><StepFiveCheckbox /></Tab.Pane>,
  }
]

class Memorize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0
    };
  }

  inc = () =>
    this.setState({
      currentStep: this.state.currentStep + 1
    })
  
    dec = () =>
    this.setState({
      currentStep: this.state.currentStep - 1
    })

  render(){
    return(
      <Grid>
        <Grid.Row textAlign="center">
          <Grid.Column>
            <Button content="Previous Step" onClick={this.dec} disabled={this.state.currentStep === 0} icon='arrow left' labelPosition='left' />
            <Button content="Next Step" onClick={this.inc} disabled={this.state.currentStep === 5} icon='arrow right' labelPosition='right' />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Tab activeIndex={this.state.currentStep} onTabChange={this.handleTabChange} menu={{ secondary: true, pointing: true, widths: 6 }} panes={panes} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row textAlign="center">
          <Grid.Column>
            <Button content="Previous Step" onClick={this.dec} disabled={this.state.currentStep === 0} icon='arrow left' labelPosition='left' />
            <Button content="Next Step" onClick={this.inc} disabled={this.state.currentStep === 5} icon='arrow right' labelPosition='right' />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}
export default Memorize;